import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[dynamicPlugin]',
    standalone: false
})
export class DynamicDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
